var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f0f4f7","padding-top":"140px"}},[_c('BlockCatalogue'),_c('BuildStructure'),_c('BlockArticles'),_c('BlockCertificates'),_c('LightBlockLocalCalculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }